const de = {
  exportTitle: 'Export FSV / DMS',
  approveTitle: 'Freizugebende Rechnungen',
  exportDate: 'Exportdatum',
  openInDMS: 'Im DMS öffnen',
  fileName: 'Dateiname',
  exportUser: 'Ersteller',
  unknownExportUser: 'unbekannt',

  tabs: {
    approved: 'Freigegebene Rechnungen',
    final: 'Exportierte Rechnungen',
    csv: 'CSV Rechnungen'
  },
  mutation: {
    exportSuccessful: 'Die Rechnungen wurden erfolgreich für den Export vorbereitet.',
    exportFailed: 'Die Rechnungen konnten nicht für den Export vorbereitet werden.',
    approveSuccessful: 'Die Rechnungen wurden erfolgreich freigegeben.',
    approveFailed: 'Die Rechnungen konnten nicht freigegeben werden.',
    denySuccessful: 'Die Rechnungen wurden erfolgreich abgelehnt.',
    denyFailed: 'Die Rechnungen konnten nicht abgelehnt werden.',
    splitInvoiceSuccessful: 'Die Rechnung wurde erfolgreich aufteilt.',
    splitInvoiceFailed: 'Die Rechnungen konnten nicht aufgeteilt werden.',
    cancelSuccessful: 'Die Rechnung wurde erfolgreich storniert.',
    cancelFailed: 'Die Rechnungen konnten nicht storniert werden.',
    deleteSuccessful: 'Die Rechnung wurde erfolgreich gelöscht.',
    deleteFailed: 'Die Rechnung konnten nicht gelöscht werden.',
    equaliseTaxRateSuccesful: 'Die Steuersätze wurden erfolgreich angepasst.',
    equaliseTaxRateFailed: 'Die Steuersätze konnten nicht angepasst werden.'
  },
  splitOrChangeTaxDialog: {
    title: 'Hinweis zur Anpassungen der Steuersätze',
    descripiton:
      'Diese Rechnung enthält Positionen mit unterschiedlichen Steuersätzen. Für die Freigabe ist es erforderlich, dass alle Rechnungspositionen denselben Steuersatz aufweisen. Sie haben zwei Möglichkeiten:',
    splitInvoice:
      'Mit dem Button "Rechnung aufteilen" können Sie die bestehende Rechnung in Teilrechnungen aufteilen. Dabei enthält jede Teilrechnung ausschließlich Positionen desselben Steuersatzes.',
    equaliseTaxRate:
      'Mit dem Button "Steuersätze angleichen" werden alle Positionen in dieser Rechnung auf den folgenden Steuersatz gesetzt: {{taxToChange}}',
    splitInvoiceButton: 'Rechnung aufteilen',
    equaliseTaxRateButton: 'Steuersätze angleichen'
  },
  exportButton: 'Rechnungen exportieren',
  departmentFilter: 'Abteilung',
  approveInvoicesDisabledTooltip: 'Es ist mindestens eine unvollständige Rechnung ausgewählt',
  confirmationDialog: {
    exportTitle: 'Rechnungen ins FSV / DMS exportieren',
    exportDialog:
      'Sind Sie sich sicher, dass sie die gewählten Rechnungen an das FSV / DMS exportieren wollen?\nIn zwei Tagen werden automatisiert Rechnungen an den jeweiligen Kunden geschickt.',
    approveTitle: 'Rechnungen freigeben',
    approveDialog:
      'Sind Sie sich sicher, dass sie die gewählten Rechnungen freigeben wollen?\nEs wird automatisch die Rechnungsnummer und das Buchungskennzeichen zur Rechnung hinzugefügt.',
    approveSplitInvoiceTitle: 'Rechnung aufteilen aufgrund verschiedener Steuersätze',
    approveSplitInvoiceDialog:
      'Die Rechnung enthält Rechnungspositionen mit verschiedenen Steuersätzen.\nDie Rechnung wird daher in {{count}} Rechnungen aufgeteilt, sodass jede Rechnung nur Positionen mit dem selben Steuersatz beinhaltet.',
    denyTitle: 'Rechnungen ablehnen',
    denyDialog: 'Sind Sie sich sicher, dass Sie die ausgewählten Rechnungen ablehnen wollen?',
    cancelTitle: 'Rechnungen stornieren',
    cancelDialog: 'Sind Sie sich sicher, dass Sie die ausgewählten Rechnungen stornieren wollen?',
    deleteTitle: 'Rechnung löschen',
    deleteDialog: 'Sind Sie sicher, dass Sie diese Rechnung löschen möchten?'
  }
};

export default de;
export type BillingFinanceTranslation = typeof de;
